<template>
  <article class="user-comments-item w-100 border-bottom py-2">
    <div
      class="d-flex flex-wrap align-items-center justify-content-between mb-2"
    >
      <div class="d-flex align-items-end gap-7">
        <!-- <span>
          <img
            class="rounded-circle"
            width="40"
            height="40"
            src="../../../../assets/images/userDefault.jpg"
            alt=""
          />
        </span> -->
        <span
          v-if="
            comment.creator &&
            (comment.creator.first_name || comment.creator.last_name)
          "
          class="text-color-grey font-w-900 fontsize-medium"
        >
          {{
            (comment.creator.first_name || "") +
            " " +
            (comment.creator.last_name || "")
          }}
        </span>
        <span class="text-color-grey font-w-900 fontsize-medium" v-else
          >کاربر بندیتو</span
        >
      </div>
      <span>
        <b-form-rating
          v-model="comment.rate"
          variant="warning"
          :readonly="true"
          class="border-0 p-0"
          size="md"
        >
        </b-form-rating>
      </span>
      <span class="text-color-999 fontsize-mini">
        {{ moment(comment.created_at).format("YYYY/MM/DD") }}
      </span>
    </div>
    <!-- <h6 class="fontsize-medium text-grey-8b text-justify line-height2">
      {{ comment.title }}
    </h6> -->
    <p class="text-grey-8b m-0 fontsize-small text-justify line-height2">
      {{ comment.body }}
    </p>
  </article>
</template>
<script>
import { BFormRating } from "bootstrap-vue";

export default {
  props: {
    comment: Object,
  },
  components: {
    BFormRating,
  },
};
</script>
